export default __webpack_public_path__ + "static/media/desktop_tc2_Cn.779e1cbe.webp";